import { render } from "./SectionHeader.vue?vue&type=template&id=a1e7dc42"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=a1e7dc42&lang=css"
script.render = render

export default script